import { render, staticRenderFns } from "./OccasionalCustomersListDialog.vue?vue&type=template&id=1ea379c6"
import script from "./OccasionalCustomersListDialog.vue?vue&type=script&lang=js"
export * from "./OccasionalCustomersListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports